/* global CONFIG */
import moment from 'moment'
import services from '../services'

export default {
  getTransactions (VueApp, conId, callback) {
    let self = this
    let transactions = VueApp.$store.state.consumer.transactions
    let pageSize = transactions.perPage
    let page = transactions.currentPage
    let pickupSince = moment(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00')
    let pickupUntil = moment(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59')
    if (transactions.date === 'all') {
      pickupSince = '2010-01-01 00:00'
      pickupUntil = moment().add(10, 'years').format('YYYY-MM-DD 23:59')
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      consId: conId,
      pageSize: pageSize,
      pageNum: page,
      order: transactions.sort.column,
      orderAsc: transactions.sort.isDesc ? 0 : 1,
      since: pickupSince,
      until: pickupUntil,
      search: transactions.search,
      status: transactions.status
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('consumer/setTrxData', {maxList: res.paging.totalItems})

        let trxList = []
        if (res.list.length) {
          let trx = res.list
          for (let i = 0; i < res.list.length; i++) {
            let provider = trx[i].provider
            // let consumer = trx[i].consumer
            let payment = trx[i].payment

            trxList.push({
              date: moment(trx[i].datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss'),
              providerId: provider.id,
              company: provider.businessName,
              rsvpId: trx[i].rsvpId,
              trxId: trx[i].eventId,
              pkgId: trx[i].packageId,
              type: trx[i].isAsap ? 'asap' : 'rsvp',
              // firstName: consumer.firstName,
              // lastName: consumer.lastName,
              // mobile: consumer.phone,
              creditCard: trx[i].cardNumber,
              bookedThrough: self.bookedThroughLabel(trx[i].deviceType),
              finalOffer: self.toFixed(payment.offer),
              chargedAmount: self.toFixed(payment.charged),
              promoUsed: self.toFixed(payment.credit),
              status: trx[i].transactionType,
              statusLabel: trx[i].status,
              paymentURL: trx[i].paymentURL,
              externalId: trx[i].externalId || '',
              notes: trx[i].notes,
              transactionType: trx[i].transactionType
            })
          }
        }
        VueApp.$store.commit('consumer/setTrxData', {list: trxList})
      }
      callback(res)
    })
  },
  exportTransactions (VueApp, conId, callback) {
    let self = this
    let transactions = VueApp.$store.state.consumer.transactions
    let pageSize = transactions.perPage
    let page = transactions.currentPage

    let since = moment(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00')
    let until = moment(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59')
    if (transactions.date === 'all') {
      since = '2010-01-01 00:00'
      until = moment().add(10, 'years').format('YYYY-MM-DD 23:59')
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      consId: conId,
      pageSize: pageSize,
      pageNum: page,
      order: transactions.sort.column,
      orderAsc: transactions.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: transactions.search,
      status: transactions.status,
      export: true
    }, res => {
      if (!res.error) {
        let trx = []
        if (res.list.length) {
          res.list.forEach(function (value) {
            trx.push(self.buildExport(value))
          })
        }
        callback(trx)
      } else {
        callback(res)
      }
    })
  },
  toFixed (value) {
    value = parseFloat(value)
    if (value < 0) {
      return '-$' + Math.abs(value).toFixed(2)
    }
    return '$' + value.toFixed(2)
  },
  bookedThroughLabel (value) {
    switch (value) {
      case 'ww': return 'Web'
      case 'admin': return 'Admin'
      case 'android': return 'Android App'
      case 'ios': return 'iOS App'
      case 'provider': return 'Provider'
      default: return value
    }

    return ''
  },
  buildExport (data) {
    let rsvpId = this.convertBrand(data.brandId) + data.rsvpId
    let serviceType = services.getServiceName(data.serviceCode)
    let payment = data.payment
    let creditCard = payment.cancelFee ? 'N/A' : data.cardNumber
    let source = this.bookedThroughLabel(data.deviceType)
    let provLicense = data.provider.accountType || ''

    if (data.packageId) {
      rsvpId = data.packageId
      serviceType = services.getServiceName('shared')
      source = 'PKG'
    }
    if (!CONFIG.useOldQuatation) {
      serviceType = data.serviceType.label
    }

    return {
      Date: moment(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
      'Booking Time': moment(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('HH:mm:ss'),
      'Pickup Time': moment(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      'Service Area': data.geofence.name,
      'Prov ID': data.provider.id,
      'Prov License': provLicense.toUpperCase(),
      'Company': data.provider.businessName,
      'RSVP ID': rsvpId,
      'Invoice ID': data.eventId,
      'Service Type': serviceType,
      'First Name': data.consumer.firstName,
      'Last Name': data.consumer.lastName,
      'Credit Card': creditCard,
      'Email': data.consumer.email,
      'Mobile': data.consumer.phone,
      'Source': source,
      'Final Offer': payment.offer || 0,
      'Charge Amount': payment.charged || 0,
      'Refunded Amount': -Math.abs(data.refundedAmount) || 0,
      'Promo Used': payment.credit || 0,
      'Driver Payment': payment.driverPay || 0,
      'Bonus': payment.bonus || 0,
      'Cancel Fees': payment.cancelFee || 0,
      'Status': data.status,
      'Pickup Location': data.pickupLocation,
      'Dropoff Location': data.dropoffLocation
    }
  },
  convertBrand (id) {
    let index = CONFIG.brands.findIndex(x => x.id === id)
    if (!id || index === -1) { return CONFIG.brands[0].code.toUpperCase() }

    return CONFIG.brands[index].code.toUpperCase()
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/consumer/transactions.js